/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

require("./src/styles/tailwindGlobal.css")
require("./src/styles/vendor/font-awesome.css")
require("./src/styles/fonts.css")
require("./src/components/footer/footerStyles.css")
require("./src/styles/base.css")
require("./src/styles/animations.css")
require("./src/styles/buttons.css")
require("./src/styles/components.css")
require("./src/styles/utility.css")
require("./src/styles/Block.css")
const React = require("react")
const { navigate } = require("@reach/router")
const { getConsentStatus } = require("./src/utils/checkConsentCookies")
const { datadogRum } = require("@datadog/browser-rum")
const { analytics } = require("./src/utils/analytics/index.js")
const {
  PerformanceObserverContextProvider,
} = require("./src/context/perfomanceObserver.js")
const { TrackingContextProvider } = require("./src/context/tracking.js")
const { ModalContextProvider } = require("./src/context/modal.js")
const { DeviceContextProvider } = require("./src/context/deviceCheck.js")
const ReactDOM = require("react-dom/client")

/*
 * Solves issues we see in production builds with the hydration of the app
 */
exports.replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (window.location === window.parent.location) {
    if (typeof window.qualified !== "undefined") {
      window.qualified("page")
    }
  }
}

exports.onClientEntry = async () => {
  if (window.location === window.parent.location) {
    const { pathname, search } = window.location
    const directSuffix = "/direct"

    if (pathname.endsWith(directSuffix)) {
      const queryParams = new URLSearchParams(search)

      queryParams.set("direct", true)
      navigate(
        `${pathname.slice(0, -directSuffix.length)}?${queryParams.toString()}`,
        { replace: true },
      ).then(() => console.debug("direct suffix removed"))
    }

    /*
     * Initialize Datadog RUM and Amplitude if the user has given consent
     */
    if (getConsentStatus() === true) {
      datadogRum.init({
        applicationId: process.env.GATSBY_DD_APPLICATION_ID,
        clientToken: process.env.GATSBY_DD_CLIENT_TOKEN,
        site: "datadoghq.com",
        service: "checkr-marketing-application",
        env: process.env.GATSBY_CURRENT_BRANCH,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 5,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      })
      await analytics().init()
      await analytics().initCandidateExperience()
    }
  }
}

exports.wrapRootElement = ({ element }) => {
  return (
    <PerformanceObserverContextProvider>
      <DeviceContextProvider>
        <TrackingContextProvider>
          <ModalContextProvider>{element}</ModalContextProvider>
        </TrackingContextProvider>
      </DeviceContextProvider>
    </PerformanceObserverContextProvider>
  )
}
